import HelperClass from "./../../config/helperClass";
import { LOGO, THEME_COLOR } from "./../../config/config";
import { useLocation } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import NotificationCenter from "./NotificationCenter";
import axios from "axios";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { ValidateEmail, axiosConfig } from "./../../config/utility";
import { jwtDecode } from "jwt-decode";
import localization from "../../localization/enUS";
import {
  getActivityLogs,
  getActivityLogsAgent,
  getActivityLogsClient,
  updateNotificationsStatus,
  updateAgentNotificationsStatus,
  updateClientNotificationsStatus,
  deleteNotifications,
  deleteAgentNotifications,
  deleteClientNotifications,
  getPrivateIntegration,
} from "./../../config/api_calls";
import { getCustomSettings } from "./../../config/reseller_api_calls";

import $ from "jquery";
const auth = new HelperClass();

export default function Header(props) {
  // function profileView() {
  //   window.$("#modalForm").modal("show");
  // }
  const location = useLocation();
  const isMountedRef = useRef(true);
  const extendSessionTimerRef = useRef(null);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
      if (extendSessionTimerRef.current) {
        clearTimeout(extendSessionTimerRef.current);
      }
    };
  }, []);

  const [toggle, setToggle] = useState(false);

  const [formLoader, setFormLoader] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [agentnotifications, setAgentNotifications] = useState([]);
  const [clientnotifications, setClientNotifications] = useState([]);
  const [disableAutoModal, setDisableAutoModal] = useState(
    localStorage.getItem("disableAutoModal") === "true",
  );

  const [notificationSidebar, setNotificationSidebar] = useState("Yes"); // Default to "Yes"

  const [integrations, setIntegrations] = useState([]);
  const [integrationLoader, setIntegrationLoader] = useState(true);

  const normalizeNotification = (notification) => {
    const timeAdded = new Date(notification.date_added);

    return {
      id: notification.id,
      title: notification.log_title,
      description: notification.log_description,
      time: timeConvert(timeAdded),
      is_read: Number(notification.is_read || 0),
      log_url: notification.log_url,
      log_type: notification.log_type,
      accountno: notification.accountno,
      agreement_accountno: notification.agreement_accountno,
      credit_app_id: notification.credit_app_id,
      rfq_accountno: notification.rfq_accountno,
      orderno: notification.orderno,
    };
  };

  const updateTabState = (tabKey, updater) => {
    if (tabKey === "admin") {
      setNotifications((prev) => updater(prev));
    } else if (tabKey === "agent") {
      setAgentNotifications((prev) => updater(prev));
    } else if (tabKey === "client") {
      setClientNotifications((prev) => updater(prev));
    }
  };

  const [timeLeft, setTimeLeft] = useState(null);
  const [showExpiryModal, setShowExpiryModal] = useState(false);
  const [sessionExtended, setSessionExtended] = useState(false);

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isExtending, setIsExtending] = useState(false);

  const getDecryptedCookie = (cookieName) => {
    const encryptedData = Cookies.get(cookieName);
    if (!encryptedData) return null;

    try {
      const decryptedBytes = CryptoJS.AES.decrypt(
        encryptedData,
        process.env.REACT_APP_SIGNATURE,
      );
      return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      // console.error(`Error decrypting ${cookieName}:`, error);
      return null;
    }
  };

  // Format time for display
  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s`;
    } else if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    } else {
      return `${seconds}s`;
    }
  };

  // Extend session function
  const extendSession = async () => {
    setIsExtending(true); // Start loading
    setErrorMessage(""); // Clear any previous errors
    setSuccessMessage(""); // Clear any previous success messages

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}refresh-token`,
        JSON.stringify({
          user_token: auth.getToken(),
          token: process.env.REACT_APP_API_TOKEN,
          api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
        }),
        axiosConfig,
      );

      //console.log("response: ", response);

      if (response.data.status === 200) {
        // Update token and session times
        const decodedToken = jwtDecode(response.data.token);
        const newExpiryTime = decodedToken.exp * 1000; // Convert to milliseconds
        const currentTime = new Date().getTime();

        // Update cookies with new token and times
        Cookies.set(
          "tkn__",
          CryptoJS.AES.encrypt(
            response.data.token,
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );

        Cookies.set(
          "session_start__",
          CryptoJS.AES.encrypt(
            currentTime.toString(),
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );

        Cookies.set(
          "session_expiry__",
          CryptoJS.AES.encrypt(
            newExpiryTime.toString(),
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );

        if (isMountedRef.current) {
          setSessionExtended(true);
          setSuccessMessage("Session extended successfully!");
          setErrorMessage("");
        }

        // Close modal after 3 seconds
        extendSessionTimerRef.current = setTimeout(() => {
          if (isMountedRef.current) {
            setSuccessMessage("");
            setShowExpiryModal(false);
          }
        }, 3000);
      } else {
        if (isMountedRef.current) {
          setErrorMessage("Failed to extend session. Please try again.");
        }
      }
    } catch (error) {
      // console.error("Error extending session:", error);
      if (isMountedRef.current) {
        setErrorMessage(
          "Network error. Please check your connection and try again.",
        );
      }
    } finally {
      if (isMountedRef.current) setIsExtending(false); // Stop loading in both success and error cases
    }
  };

  // Session timer effect
  useEffect(() => {
    const updateTimer = () => {
      const sessionExpiry = getDecryptedCookie("session_expiry__");

      if (!sessionExpiry) {
        setTimeLeft(null);
        return;
      }

      const expiryTime = parseInt(sessionExpiry);
      const currentTime = new Date().getTime();
      const remainingTime = expiryTime - currentTime;

      if (remainingTime <= 0) {
        // Session expired
        setTimeLeft(0);
        auth.logout();
        return;
      }

      setTimeLeft(remainingTime);

      // Show modal 10 minutes before expiry
      const tenMinutes = 10 * 60 * 1000;
      if (
        remainingTime <= tenMinutes &&
        !sessionExtended &&
        !localStorage.getItem("modalClosedManually")
      ) {
        setShowExpiryModal(true);
      }
    };

    // Update immediately
    updateTimer();

    // Update every second
    const timer = setInterval(updateTimer, 1000);

    return () => clearInterval(timer);
  }, [showExpiryModal, sessionExtended]);

  // Reset sessionExtended flag when session is actually extended
  useEffect(() => {
    if (sessionExtended) {
      const resetTimer = setTimeout(() => {
        setSessionExtended(false);
      }, 5000); // Reset after 5 seconds

      return () => clearTimeout(resetTimer);
    }
  }, [sessionExtended]);

  function timeConvert(date) {
    const seconds = Math.floor((new Date() - date) / 1000);
    const interval = seconds / 31536000;

    if (interval > 1) {
      return Math.floor(interval) + " years ago";
    }
    const interval2 = seconds / 2592000;
    if (interval2 > 1) {
      return Math.floor(interval2) + " months ago";
    }
    const interval3 = seconds / 86400;
    if (interval3 > 1) {
      return Math.floor(interval3) + " days ago";
    }
    const interval4 = seconds / 3600;
    if (interval4 > 1) {
      return Math.floor(interval4) + " hours ago";
    }
    const interval5 = seconds / 60;
    if (interval5 > 1) {
      return Math.floor(interval5) + " minutes ago";
    }
    return Math.floor(seconds) + " seconds ago";
  }

  const handleCheckboxChange = () => {
    const newValue = !disableAutoModal;
    setDisableAutoModal(newValue);
    localStorage.setItem("disableAutoModal", String(newValue));
  };

  const getNotifications = async (userType) => {
    try {
      let response;
      let notificationData = [];

      if (userType === "admin") {
        response = await getActivityLogs(auth.getAccount(), auth.getToken());
        notificationData =
          response?.data?.status === 200 && Array.isArray(response.data.data)
            ? response.data.data
            : [];
      } else if (userType === "agent") {
        response = await getActivityLogsAgent(auth.getAccount(), auth.getToken());
        notificationData =
          response?.data?.status === 200 &&
          response?.data?.data &&
          Array.isArray(response.data.data.data)
            ? response.data.data.data
            : [];
      } else if (userType === "client") {
        response = await getActivityLogsClient(auth.getAccount(), auth.getToken());
        notificationData =
          response?.data?.status === 200 &&
          response?.data?.data &&
          Array.isArray(response.data.data.data)
            ? response.data.data.data
            : [];
      }

      const normalized = notificationData
        .map(normalizeNotification);

      if (isMountedRef.current) {
        if (userType === "admin") {
          setNotifications(normalized);
        } else if (userType === "agent") {
          setAgentNotifications(normalized);
        } else if (userType === "client") {
          setClientNotifications(normalized);
        }
      }
    } catch (error) {
      // console.error("Error fetching notifications:", error);
    } finally {
      if (isMountedRef.current) setFormLoader(false);
    }
  };

  const applyBulkRead = async (tabKey, notificationIds) => {
    try {
      let response;

      if (tabKey === "admin") {
        response = await updateNotificationsStatus(
          auth.getAccount(),
          auth.getToken(),
          notificationIds,
          1
        );
      } else if (tabKey === "agent") {
        response = await updateAgentNotificationsStatus(
          auth.getAccount(),
          auth.getToken(),
          notificationIds,
          1
        );
      } else {
        response = await updateClientNotificationsStatus(
          auth.getAccount(),
          auth.getToken(),
          notificationIds,
          1
        );
      }

      if (response?.data?.status === 200) {
        updateTabState(tabKey, (items) =>
          items.map((item) =>
            notificationIds.includes(item.id) ? { ...item, is_read: 1 } : item
          )
        );
        return true;
      }
    } catch (error) {
      // console.error("Error marking notifications as read:", error);
    }

    return false;
  };

  const undoBulkRead = async (tabKey, notificationIds) => {
    try {
      let response;

      if (tabKey === "admin") {
        response = await updateNotificationsStatus(
          auth.getAccount(),
          auth.getToken(),
          notificationIds,
          0
        );
      } else if (tabKey === "agent") {
        response = await updateAgentNotificationsStatus(
          auth.getAccount(),
          auth.getToken(),
          notificationIds,
          0
        );
      } else {
        response = await updateClientNotificationsStatus(
          auth.getAccount(),
          auth.getToken(),
          notificationIds,
          0
        );
      }

      if (response?.data?.status === 200) {
        updateTabState(tabKey, (items) =>
          items.map((item) =>
            notificationIds.includes(item.id) ? { ...item, is_read: 0 } : item
          )
        );
        return true;
      }
    } catch (error) {
      // console.error("Error undoing notification state:", error);
    }

    return false;
  };

  const deleteBulkNotifications = async (tabKey, notificationIds) => {
    try {
      let response;

      if (tabKey === "admin") {
        response = await deleteNotifications(
          auth.getAccount(),
          auth.getToken(),
          notificationIds
        );
      } else if (tabKey === "agent") {
        response = await deleteAgentNotifications(
          auth.getAccount(),
          auth.getToken(),
          notificationIds
        );
      } else {
        response = await deleteClientNotifications(
          auth.getAccount(),
          auth.getToken(),
          notificationIds
        );
      }

      if (response?.data?.status === 200) {
        updateTabState(tabKey, (items) =>
          items.filter((item) => !notificationIds.includes(item.id))
        );
        return true;
      }
    } catch (error) {
      // console.error("Error deleting notifications:", error);
    }

    return false;
  };

  useEffect(() => {
    getNotifications("admin");
    getNotifications("agent");
    getNotifications("client");
    getPrivateIntegrations();
    getCustomSetting();

    if (
      location.pathname === "/dashboard" &&
      notificationSidebar === "Yes" &&
      (notifications.some((notification) => notification.is_read === 0) ||
        agentnotifications.some((notification) => notification.is_read === 0) ||
        clientnotifications.some((notification) => notification.is_read === 0))
    ) {
      setToggle(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (
      location.pathname === "/dashboard" &&
      notificationSidebar === "Yes" &&
      !disableAutoModal &&
      (notifications.some((notification) => notification.is_read === 0) ||
        agentnotifications.some((notification) => notification.is_read === 0) ||
        clientnotifications.some((notification) => notification.is_read === 0))
    ) {
      setToggle(true);
    }
  }, [notifications, agentnotifications, clientnotifications]);

  useEffect(() => {
    const handleBodyClick = (event) => {
      if (
        toggle &&
        event.target.isConnected &&
        !document.getElementById("notification-modal").contains(event.target)
      ) {
        setToggle(false);
      }
    };
    document.body.addEventListener("click", handleBodyClick);
    return () => {
      document.body.removeEventListener("click", handleBodyClick);
    };
  }, [toggle]);

  function classCheck() {
    var menu_items = $(".nk-sidebar");
    if (menu_items.hasClass("nk-sidebar-active")) {
    } else {
      $(".nk-sidebar").addClass("nk-sidebar-active");
    }
  }

  function navigateLink(link) {
    props.mainProps.history.push(link);
  }

  const handleToggle = () => {
    setToggle(!toggle);
  };

  // Updated function to handle the API response structure
  const getPrivateIntegrations = async () => {
    try {
      setIntegrationLoader(true);
      const getIntegrations_res = await getPrivateIntegration(
        auth.getAccount(),
        auth.getToken(),
      );
      //console.log("getIntegrations_res: ", getIntegrations_res.data);

      if (isMountedRef.current) {
        if (getIntegrations_res.data.status === 200) {
          setIntegrations(getIntegrations_res.data.data || []);
        } else {
          //console.log("No integrations found");
          setIntegrations([]);
        }
        setIntegrationLoader(false);
      }
    } catch (error) {
      // console.error("Error fetching integrations:", error);
      if (isMountedRef.current) {
        setIntegrations([]);
        setIntegrationLoader(false);
      }
    }
  };

  // Category color mapping
  const getCategoryStyle = (category) => {
    const styles = {
      Dialer: { bg: "#e3f2fd", color: "#1976d2", border: "#90caf9" },
      CRM: { bg: "#f3e5f5", color: "#7b1fa2", border: "#ce93d8" },
      Analytics: { bg: "#e8f5e8", color: "#388e3c", border: "#a5d6a7" },
      Communication: { bg: "#fff3e0", color: "#f57c00", border: "#ffcc02" },
      Default: { bg: "#f5f5f5", color: "#666", border: "#ddd" },
    };
    return styles[category] || styles["Default"];
  };

  const handleIntegrationClick = () => {
    const accountno = auth.getAccount();

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "https://auth.onboardsoft.com:3000/admin_obs/sso/login";

    const hiddenField = document.createElement("input");
    hiddenField.type = "hidden";
    hiddenField.name = "accountno";
    hiddenField.value = accountno;

    form.appendChild(hiddenField);
    form.target = "_blank"; // Open in new tab
    form.style.display = "none";

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  const handleCloseModal = () => {
    setShowExpiryModal(false);
    localStorage.setItem("modalClosedManually", "true");
  };

  const handleModalBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      setShowExpiryModal(false);
    }
  };

  const getCustomSetting = async () => {
    try {
      const getCustomSetting_res = await getCustomSettings(
        auth.getAccount(),
        auth.getToken(),
      );
      //console.log("getCustomSetting_res: ", getCustomSetting_res.data);
      if (
        getCustomSetting_res.data.status === 200 &&
        getCustomSetting_res.data.data &&
        getCustomSetting_res.data.data.length > 0 &&
        isMountedRef.current
      ) {
        setNotificationSidebar(
          getCustomSetting_res.data.data[0].notification_sidebar || "Yes",
        );
      }
    } catch (error) {
      // console.error("Error fetching settings:", error);
    }
  };

  return (
    <>
      {showExpiryModal && (
        <div
          className="modal fade show"
          onClick={handleModalBackdropClick}
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 1050,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "520px", width: "100%", margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: "12px",
                border: "none",
                boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
              }}
            >
              {/* Header */}
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1.25rem",
                  borderBottom: "1px solid #e5e7eb",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <h5
                  className="modal-title"
                  style={{
                    margin: 0,
                    fontWeight: 600,
                    fontSize: "1.125rem",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    color: "#364a63",
                  }}
                >
                  <em className="icon ni ni-alert-circle" />
                  Session Expiring Soon
                </h5>
                <div
                  onClick={() => handleCloseModal()}
                  className="modal-close-button"
                  style={{
                    cursor: "pointer",
                    padding: "6px",
                    borderRadius: "6px",
                    transition: "background 0.2s",
                  }}
                  title="Close"
                >
                  <em
                    className="icon ni ni-cross"
                    style={{ fontSize: "20px", color: "#6b7280" }}
                  />
                </div>
              </div>

              {/* Body */}
              <div
                className="modal-body"
                style={{
                  padding: "1.75rem 2rem",
                  textAlign: "center",
                  backgroundColor: "#fff",
                }}
              >
                {errorMessage && (
                  <div className="example-alert mb-3">
                    <div className="alert alert-pro alert-danger">
                      <div className="alert-text">
                        <h4>Error</h4>
                        <p>{errorMessage}</p>
                      </div>
                    </div>
                  </div>
                )}
                {successMessage && (
                  <div className="example-alert mb-3">
                    <div className="alert alert-pro alert-success">
                      <div className="alert-text">
                        <h4>Success</h4>
                        <p>{successMessage}</p>
                      </div>
                    </div>
                  </div>
                )}

                <em
                  className="icon ni ni-clock"
                  style={{
                    fontSize: "2.5rem",
                    color: "#364a63",
                    marginBottom: "1rem",
                    display: "block",
                  }}
                ></em>

                <p
                  style={{
                    fontSize: "1rem",
                    marginBottom: "0.5rem",
                    color: "#374151",
                  }}
                >
                  Your session will expire in:
                </p>
                <h4
                  style={{
                    fontSize: "1.75rem",
                    fontWeight: 700,
                    color: "#dc2626",
                    marginBottom: "1rem",
                  }}
                >
                  {timeLeft ? formatTime(timeLeft) : "0s"}
                </h4>

                <p
                  style={{
                    color: "#6b7280",
                    fontSize: "0.95rem",
                    marginBottom: "1rem",
                  }}
                >
                  Do you want to stay signed in and extend your session?
                </p>

                <div
                  className="alert alert-warning"
                  style={{
                    backgroundColor: "#fef3c7",
                    borderColor: "#fde68a",
                    color: "#92400e",
                    borderRadius: "6px",
                    padding: "12px",
                    fontSize: "0.875rem",
                  }}
                >
                  <strong>Note:</strong> You will be automatically logged out if
                  no action is taken.
                </div>
              </div>

              {/* Footer */}
              <div
                className="modal-footer"
                style={{
                  padding: "1rem 2rem",
                  borderTop: "1px solid #e5e7eb",
                  backgroundColor: "#f9fafb",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "0.75rem",
                  borderBottomLeftRadius: "12px",
                  borderBottomRightRadius: "12px",
                }}
              >
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => {
                    setShowExpiryModal(false);
                    auth.logout();
                  }}
                >
                  <em className="icon ni ni-signout mr-1"></em>
                  Sign Out
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={extendSession}
                  disabled={isExtending}
                >
                  {isExtending ? (
                    <>
                      <div
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        style={{
                          width: "1rem",
                          height: "1rem",
                          marginRight: "8px",
                        }}
                      >
                        <span className="visually-hidden"></span>
                      </div>
                    </>
                  ) : (
                    <>
                      <em className="icon ni ni-reload mr-1"></em>
                      Extend Session
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="nk-header nk-header-fixed is-light">
        <div className="container-fluid">
          <div className="nk-header-wrap">
            <div className="nk-menu-trigger d-xl-none ml-n1">
              <a
                className="nk-nav-toggle nk-quick-nav-icon"
                data-target="sidebarMenu"
              >
                <em
                  className="icon ni ni-menu"
                  onClick={() => classCheck()}
                ></em>
              </a>
            </div>

            <div className="nk-header-brand d-xl-none">
              <a href="/" className="logo-link">
                <img className="logo-light logo-img" src={LOGO} alt="logo" />
                <img
                  className="logo-dark logo-img"
                  src={LOGO}
                  alt="logo-dark"
                />
              </a>
            </div>

            <div className="nk-header-tools">
              <ul className="nk-quick-nav">
                {timeLeft !== null && timeLeft <= 600000 && (
                  <li className="session-timer-container">
                    <div
                      className="session-timer"
                      style={{
                        cursor: timeLeft <= 600000 ? "pointer" : "default",
                        padding: "8px 12px",
                        background: timeLeft <= 600000 ? "#ffe6e6" : "#f8f9fa",
                        border: `1px solid ${
                          timeLeft <= 600000 ? "#ff9999" : "#dee2e6"
                        }`,
                        borderRadius: "6px",
                        fontSize: "12px",
                        fontWeight: "500",
                        color: timeLeft <= 600000 ? "#d32f2f" : "#666",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                      onClick={() => {
                        if (timeLeft <= 600000) {
                          localStorage.removeItem("modalClosedManually");
                          setShowExpiryModal(true);
                        }
                      }}
                      title={
                        timeLeft <= 600000 ? "Click to extend session" : ""
                      }
                    >
                      <em
                        className="icon ni ni-clock"
                        style={{ fontSize: "14px" }}
                      />
                      <span>Session: {formatTime(timeLeft)}</span>
                    </div>
                  </li>
                )}
                {props.isNdaSigned === true ? (
                  <li>
                    {/*<a
                    className="btn"
                    style={{ backgroundColor: THEME_COLOR, color: "white" }}
                  >
                    <em className="icon ni ni-share-fill"></em>
                    <span>ShareLink</span>{" "}
                  </a>*/}
                  </li>
                ) : null}

                {/* Grid/Integrations Dropdown - Updated with proper styling */}
                {/* Grid/Integrations Dropdown - Simplified */}
                {/* {integrations.length > 0 && (
                  <li className="dropdown integrations-dropdown">
                    <a
                      href="#"
                      className="dropdown-toggle nk-quick-nav-icon"
                      data-toggle="dropdown"
                    >
                      <em
                        className="icon ni ni-grid-box-alt-fill"
                        style={{ fontSize: "1.2rem" }}
                      ></em>
                    </a>
                    <div
                      className="dropdown-menu dropdown-menu-lg dropdown-menu-right dropdown-menu-s1"
                      style={{ minWidth: "320px" }}
                    >
                      <div className="dropdown-inner">
                        <div
                          className="dropdown-body"
                          style={{ maxHeight: "400px", overflowY: "auto" }}
                        >
                          {integrationLoader ? (
                            <div className="text-center p-4">
                              <div
                                className="spinner-border spinner-border-sm"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            </div>
                          ) : (
                            <ul className="link-list" style={{ margin: 0 }}>
                              {integrations.map((integration, index) => {
                                return (
                                  <li
                                    key={integration.id || index}
                                    style={{ marginBottom: "8px" }}
                                  >
                                    <a
                                      href="#"
                                      onClick={() =>
                                        handleIntegrationClick(integration)
                                      }
                                      style={{
                                        display: "block",
                                        padding: "12px 16px",
                                        border: "1px solid #e5e7eb",
                                        borderRadius: "8px",
                                        background: "white",
                                        textDecoration: "none",
                                        transition: "box-shadow 0.2s ease",
                                        boxShadow:
                                          "0 1px 2px rgba(0, 0, 0, 0.03)",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flex: 1,
                                          }}
                                        >
                                          <img
                                            src={`../../assets/images/integrations/${integration.integration_img}`}
                                            alt={integration.integration_title}
                                            style={{
                                              width: "36px",
                                              height: "36px",
                                              borderRadius: "8px",
                                              border: "2px solid #fff",
                                              boxShadow:
                                                "0 2px 6px rgba(0,0,0,0.06)",
                                              marginRight: "12px",
                                            }}
                                            onError={(e) => {
                                              e.target.src =
                                                "../../assets/images/integrations/default.png";
                                            }}
                                          />
                                          <span
                                            style={{
                                              fontWeight: "600",
                                              fontSize: "14px",
                                              color: "#111827",
                                            }}
                                          >
                                            {integration.integration_title}
                                          </span>
                                        </div>

                                        <em
                                          className="icon ni ni-arrow-right"
                                          style={{
                                            color: "#9ca3af",
                                            fontSize: "16px",
                                            opacity: 0.8,
                                          }}
                                        ></em>
                                      </div>
                                    </a>
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </div>
                        <div
                          className="dropdown-foot"
                          style={{
                            borderTop: "1px solid #eee",
                            paddingTop: "0.75rem",
                          }}
                        >
                          <div className="text-center">
                            <a
                              href="/integrations"
                              style={{
                                fontSize: "12px",
                                color: "#6366f1",
                                textDecoration: "none",
                              }}
                            >
                              <em className="icon ni ni-external mr-1"></em>
                              Manage All Integrations
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                )} */}

                <li className="dropdown user-dropdown">
                  <a
                    href="#"
                    className="dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    <div className="user-toggle">
                      <div className="user-avatar sm">
                        <em className="icon ni ni-user-alt"></em>
                      </div>
                      <div className="user-info d-none d-md-block">
                        <div className="user-status">{auth.getName()}</div>
                        <div className="user-name dropdown-indicator">
                          {auth.getCompName()}
                        </div>
                      </div>
                    </div>
                  </a>
                  <div className="dropdown-menu dropdown-menu-md dropdown-menu-right dropdown-menu-s1">
                    <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
                      <div className="user-card">
                        <div className="user-avatar">
                          <span>{(auth.getCompName() || "NA").substring(0, 2)}</span>
                        </div>
                        <div className="user-info">
                          <span className="lead-text">
                            {auth.getCompName()}
                          </span>
                          <span className="sub-text">{auth.getEmail()}</span>
                        </div>
                      </div>
                    </div>
                    <div className="dropdown-inner">
                      <ul className="link-list">
                        <li>
                          <a href="#" onClick={props.modalOpen}>
                            <em className="icon ni ni-user-alt"></em>
                            <span>View Profile</span>
                          </a>
                        </li>
                        {auth.getUserType() !== "Sub" ? (
                          <li>
                            <a style={{ cursor: "pointer" }} href="/sub_users">
                              <em className="icon ni ni-user-list"></em>
                              <span>Sub Users</span>
                            </a>
                          </li>
                        ) : null}
                        {/* {auth.getUserType() !== "Sub" ? (
                          <li>
                            <a
                              style={{ cursor: "pointer" }}
                              href="/admin_roles"
                            >
                              <em className="icon ni ni-grid-c"></em>
                              <span>Admin Menu</span>
                            </a>
                          </li>
                        ) : null} */}
                        <li>
                          <a href="#" onClick={props.modalLogin}>
                            <em className="icon ni ni-signin"></em>
                            <span>Login Details</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="dropdown-inner">
                      <ul className="link-list">
                        <li
                          onClick={() => auth.logout()}
                          style={{ cursor: "pointer" }}
                        >
                          <a>
                            <em className="icon ni ni-signout"></em>
                            <span>Sign out</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li className="dropdown notification-dropdown mr-n1">
                  <a
                    className="dropdown-toggle nk-quick-nav-icon"
                    onClick={handleToggle}
                  >
                    <div
                      className={
                        notifications.some(
                          (notification) => notification.is_read === 0,
                        ) ||
                        agentnotifications.some(
                          (notification) => notification.is_read === 0,
                        ) ||
                        clientnotifications.some(
                          (notification) => notification.is_read === 0,
                        )
                          ? "icon-status icon-status-info"
                          : "icon-status"
                      }
                    >
                      <em className="icon ni ni-bell"></em>
                    </div>
                  </a>
                  <div
                    className={`card-aside card-aside-right user-aside custom-dropdown-menu   dropdown-menu-right  toggle-slide toggle-slide-right${
                      toggle ? " content-active" : ""
                    }`}
                    id="notification-modal"
                    style={{
                      overflowY: "auto",
                      maxHeight: "200px",
                      scrollbarWidth: "thin",
                    }}
                  >
                    <div className="card-inner-group" data-simplebar>
                      <div className="p-2">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginLeft: "3px",
                            marginRight: "1px",
                          }}
                        >
                          <h5>Notifications</h5>
                          <a
                            onClick={handleToggle}
                            style={{
                              fontSize: "1.5rem",
                              paddingLeft: "0.5rem",
                              cursor: "pointer",
                              marginBottom: "0.5rem",
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        {/* <div className="dropdown-head-notification">
                        <span className="sub-title nk-dropdown-title">
                          Notifications
                        </span>
                        <a href="#" onClick={markAllAsRead}>
                          Mark All as Read
                        </a>
                      </div> */}
                      </div>
                      <div
                        className="card card-preview"
                        id="headerDivNotification"
                      >
                        <div
                          className="card-inner"
                          style={{ padding: "0 1rem 1rem 1rem" }}
                        >
                          <NotificationCenter
                            compact={true}
                            loading={formLoader}
                            title="Notifications"
                            onBulkMarkRead={applyBulkRead}
                            onUndo={undoBulkRead}
                            onDelete={deleteBulkNotifications}
                            tabs={[
                              {
                                key: "client",
                                label: "Clients",
                                items: clientnotifications,
                                viewAllHref: "/notifications/client",
                                emptyText: "You have no client notifications yet.",
                              },
                              {
                                key: "agent",
                                label: localization.specificPortals.agentsLabel,
                                items: agentnotifications,
                                viewAllHref: "/notifications/agent",
                                emptyText: `You have no ${localization.specificPortals.agentLabel.toLowerCase()} notifications yet.`,
                              },
                              {
                                key: "admin",
                                label: "Admin",
                                items: notifications,
                                viewAllHref: "/notifications/admin",
                                emptyText: "You have no admin notifications yet.",
                              },
                            ]}
                          />
                        </div>
                      </div>
                      <div
                        className="custom-control custom-checkbox mb-4"
                        style={{ paddingLeft: "3.2rem" }}
                      >
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="customCheck1"
                          checked={disableAutoModal}
                          onChange={handleCheckboxChange}
                        autoComplete="new-password" />
                        <label
                          className="custom-control-label"
                          htmlFor="customCheck1"
                        >
                          Don't show this again
                        </label>
                      </div>
                      {/* <div className="dropdown-body">
                      <div className="nk-notification">
                        {formLoader === true ? (
                          FormLoader()
                        ) : (
                          <>
                            {notifications.length > 0 ? (
                              notifications.map((notification, index) => (
                                <Notifications
                                  key={index}
                                  notification={notification}
                                />
                              ))
                            ) : (
                              <div className="nk-notification-item dropdown-inner">
                                <div className="nk-notification-icon">
                                  <em className="icon icon-circle bg-warning-dim ni ni-info"></em>
                                </div>
                                <div className="nk-notification-content">
                                  <div className="nk-notification-text">
                                    You have <span>no notifications</span> yet
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div> */}
                      {/* <div className="dropdown-foot center">
                      <a href="/notifications">View All</a>
                    </div> */}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
